module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/modal/client-detail/top/showBigImages/button-show-big-images/button-show-big-images.component.css
// module id = ./src/app/app_manager/modal/client-detail/top/showBigImages/button-show-big-images/button-show-big-images.component.css
// module chunks = main